<template>
  <app-widget
    v-show="visible"
    :overflow="false"
    :level="1"
    :title="$t('page.dashboard.latestUpdates')"
    :view-state="viewState"
    class="app-widget"
  >
    <template #action>
      <view-all-button :level="1" @click="goToUpdateOverviewPage" />
    </template>

    <template #ready>
      <div class="widget-container">
        <a
          v-for="(item, i) in data"
          :key="i"
          :href="item.link"
          :target="item.linkType"
        >
          <content-card
            :about="item.about"
            :image="item.image"
            :title="item.title"
            class="pointer"
          />
        </a>
      </div>
    </template>
  </app-widget>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type {
  IDigitalContentUpdate,
  IDigitalContentUpdateEntry,
  IOrganization
} from '@rready/sdk';
import ContentCard from '../../module/digitalContent/ContentCard.vue';
import { useProductStore } from '../../store/productStore';
import { useContextStore } from '../../store/contextStore';

export default defineComponent({
  name: 'LatestUpdatesWidget',
  components: {
    ContentCard
  },
  data() {
    return {
      loading: false,
      data: [] as IDigitalContentUpdateEntry[]
    };
  },
  async created(): Promise<void> {
    this.loading = true;
    try {
      const data = (await this.$gateway.digitalContent.loadDigitalContentList(
        this.productId,
        'updates',
        'homepage'
      )) as IDigitalContentUpdate[];
      const amountOfDigitalContent =
        this.organization.productCustomization[this.productId].dashboardOverview
          ?.amountOfDigitalContent ?? 2;
      this.data = data
        .map((content: IDigitalContentUpdate) => this.$res(content.resources!))
        .slice(0, amountOfDigitalContent);
    } catch (e: any) {
      console.error('Could not load latest updates', e);
      this.$toast(this.$t('error.general').toString());
    } finally {
      this.loading = false;
    }
  },
  computed: {
    productId(): string {
      return useProductStore().productId!;
    },
    organization(): IOrganization {
      return useContextStore().organization;
    },
    visible(): boolean {
      return this.viewState === 'ready';
    },
    viewState(): 'loading' | 'empty' | 'ready' {
      if (this.loading) {
        return 'loading';
      } else if (this.data.length === 0) {
        return 'empty';
      } else {
        return 'ready';
      }
    }
  },
  methods: {
    goToUpdateOverviewPage(): void {
      this.$router.push({ name: 'UpdateOverview' });
    }
  }
});
</script>

<style lang="scss" scoped>
.widget-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 18px;
}
</style>
